import './conversions.scss';

import { WalletCard } from '@basqet-dashboard/common/components';
import {
  useFetchCollectionsWallets,
  useFetchWalletConversions
} from '@basqet-dashboard/common/hooks/queries';
import React from 'react';

import { RecentConversions } from './recent-conversions';

/**
 * Conversions landing page — figma nodes 13092:82610 + 13149:16384.
 *
 * Page title ("Your Conversions"), wallet tabs (All / Fiat / Crypto)
 * and the Convert CTA are all rendered by the shared Navbar from the
 * merchant menu config (packages/merchant/src/config/menu.js →
 * Conversions entry). This page renders only the wallet grid and the
 * Recent Conversions table.
 *
 * @returns {JSX.Element}
 */
function Conversions() {
  const { walletsToDisplay, isLoading: isLoadingWallets } = useFetchCollectionsWallets();
  const {
    filteredConversions,
    totalLoaded,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetch,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    dateFilter,
    setDateFilter
  } = useFetchWalletConversions();

  return (
    <div className="conversions">
      <div className="conversions__wallets">
        {isLoadingWallets && <p className="conversions__wallets-loading">Loading wallets…</p>}
        {!isLoadingWallets && walletsToDisplay.length === 0 && (
          <p className="conversions__wallets-empty">No wallets to display.</p>
        )}
        {walletsToDisplay.map((wallet) => (
          <WalletCard wallet={wallet} key={wallet.id} />
        ))}
      </div>

      <RecentConversions
        conversions={filteredConversions}
        totalLoaded={totalLoaded}
        isLoading={isLoading}
        isFetching={isFetching}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        onRefresh={refetch}
        setSearchQuery={setSearchQuery}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        dateFilter={dateFilter}
        setDateFilter={setDateFilter}
      />
    </div>
  );
}

export { Conversions };
